import { AfterViewInit,Component,ElementRef,EventEmitter,Input,OnDestroy,Output,ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    AnnotationService,
    BookmarkViewService,
    FormDesignerService,
    FormFieldsService,
    InkAnnotationSettings,
    LinkAnnotationService,
    MagnificationService,
    NavigationService,
    PageOrganizerService,
    PdfViewerComponent,
    PrintService,
    TextSearchService,
    TextSelectionService,
    ThumbnailViewService,
    ToolbarService
} from '@syncfusion/ej2-angular-pdfviewer';

import { DocumentState } from '@dave/types';
import { Actions,ofType } from '@ngrx/effects';
import { ToolbarSettingsModel } from '@syncfusion/ej2-pdfviewer';
import { AllowedInteraction,ContextMenuItem,SignStampItem } from '@syncfusion/ej2-pdfviewer/src/pdfviewer/base/types';
import { CustomStampSettings } from '@syncfusion/ej2-pdfviewer/src/pdfviewer/pdfviewer';
import { ToastrService } from 'ngx-toastr';
import {
    BehaviorSubject,firstValueFrom,
    merge,
    of,
    Subject,
    Subscription,
    switchMap,
    timer
} from 'rxjs';
import { debounceTime, distinctUntilChanged,filter,map,take, takeUntil } from 'rxjs/operators';
import { EventEntity } from '../../../../dave-data-module/entities/event.entity';
import { VersionEntity } from '../../../../dave-data-module/entities/version.entity';
import { ComponentCanDeactivate } from '../../../../dave-data-module/guards/pending-changes.guard';
import { FileDataService } from '../../../../dave-data-module/services/file-data.service';
import { HttpService } from '../../../../dave-data-module/services/http.service';
import { State } from '../../../../dave-data-module/State';
import { BaseActionTypes } from '../../../../dave-data-module/State/actions/base.actions';
import { FilesActionTypes } from '../../../../dave-data-module/State/actions/files.actions';
import { getToken } from '../../../../dave-data-module/State/selectors/base.selectors';
import { BreakpointObserverService } from '../../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import { blobToBase64, isNotNullOrUndefined, ProductName } from '../../../../helper/helper';
import { LoadingService } from '../../../../services/loading.service';
import { PdfToolsService } from '../../../../services/pdf-tools.service';
import {
    SetQuantityDialogGaebComponent,
    SetQuantityDialogGaebComponentDialogData, SetQuantityDialogGaebComponentDialogReturnData,
} from '../../set-quantity-dialog-gaeb/set-quantity-dialog-gaeb.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import {
    PdfEditableDialogComponent,
    PDFEditableDialogData, PDFEditableDialogReturnData,
} from '../pdf-editable-dialog/pdf-editable-dialog.component';
import { FileEntity } from 'src/app/dave-data-module/entities/file.entity';
import { RemarkPopupComponent, RemarkPopupComponentDialogData } from '../remark-popup/remark-popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

// L10n.load(TranslationObject);

@Component({
    selector: 'app-pdf-editor-legacy',
    templateUrl: './pdf-editor-legacy.component.html',
    styleUrls: ['./pdf-editor-legacy.component.scss'],
    providers: [
        LinkAnnotationService,
        BookmarkViewService,
        MagnificationService,
        ThumbnailViewService,
        ToolbarService,
        NavigationService,
        AnnotationService,
        TextSearchService,
        TextSelectionService,
        PrintService,
        FormFieldsService,
        FormDesignerService,
        PageOrganizerService,
    ],
})
export class PdfEditorLegacyComponent implements AfterViewInit, OnDestroy, ComponentCanDeactivate {
    public ServiceUrl = this.api.GetUrl('pdfviewer', 'sfdt');
    public ServiceGetElements = this.api.GetUrl('pdfviewer/GetElements', 'sfdt');
    public ServiceUploadNewVersionFromImages = this.api.GetUrl('pdfviewer/UploadNewVersionFromImages', 'sfdt');
    protected readonly resourceUrl = window.location.origin + "/assets/ej2-pdfviewer-lib"; //this.api.GetUrl('assets/ej2-pdfviewer-lib', '');
    private readonly autosaveServiceUrl = this.api.GetUrl('pdfviewer/autosave/pdfviewer', 'sfdt');

    // Intervall für die automatische Speicherung in Millisekunden
    private readonly AUTOSAVE_INTERVAL = 10_000;

    // Zeit in Millisekunden, nach der die automatische Speicherung gestoppt wird, wenn keine Änderungen mehr erfolgen
    private readonly STOP_AUTOSAVE_TIME = 15_000;

    // Subject, das ausgelöst wird, wenn eine Änderung im PDF-Viewer erfolgt
    private readonly editSubject = new Subject<void>();

    private destroy$ = new Subject<void>();

    // Timer für die automatische Speicherung
    private autosaveTimerSub: Subscription | null = null;
    private autosaveTimerRunning = false;

    // Subscription für die Debounce-Funktion, um die automatische Speicherung zu stoppen, wenn keine Änderungen mehr erfolgen
    private debounceSub?: Subscription;

    // PDF-Viewer Container Element, zum Festlegen von Event-Listenern
    private viewerContainer: HTMLElement | null = null;

    // Liste der Events, die Änderungen im PDF-Viewer repräsentieren
    private readonly editEvents: string[] = [
        'formFieldPropertiesChange', 'formFieldMove', 'formFieldRemove', 'formFieldResize', 'formFieldAdd',
        'addSignature', 'removeSignature', 'resizeSignature', 'moveSignature', 'signaturePropertiesChange',
        'annotationRemove', 'annotationResize', 'annotationAdd', 'annotationMove', 'annotationPropertiesChange',
        'commentDelete', 'commentEdit', 'commentAdd',
    ];

    // public Service = 'http://localhost:6001/api/pdfviewer';
    //public ServiceGetElements = 'http://localhost:54216/pdfviewer/GetElements';
    //public ServiceUploadNewVersionFromImages = 'http://localhost:54216/pdfviewer/UploadNewVersionFromImages';
    @Output() FileLoaded = new EventEmitter<void>();
    @Input() Version: VersionEntity;
    @Input() SigningMode = false;
    @Input() SetMapMarkerMode = false;
    private setCheckedButtonDocumentId$ = new BehaviorSubject<number | null>(null);
    @Input() set SetCheckedButtonDocumentId(id: number) {
        if (id !== this.setCheckedButtonDocumentId$.value) {
            this.setCheckedButtonDocumentId$.next(id);
        }
    }
    get SetCheckedButtonDocumentId() {
        return this.setCheckedButtonDocumentId$.value;
    }
    protected CheckedFile$: Observable<FileEntity> = this.setCheckedButtonDocumentId$.pipe(switchMap((id) =>
        (id ? this.fs.GetFileById$(id).pipe(map((file) => file)) : null)
    ));
    @ViewChild('pdfViewer') PdfViewer: PdfViewerComponent;
    public Editing = false;
    public SaveButton = false;
    private loadedVersion: VersionEntity = null;

    protected inkAnnotationSettings: InkAnnotationSettings = {
        thickness: 2,
        // strokeColor: '#2a9916',
        strokeColor: '#00796b',
    } as InkAnnotationSettings;
    public ToolbarSettings: ToolbarSettingsModel = {
        toolbarItems: [
            'OpenOption',
            'PageNavigationTool',
            'MagnificationTool',
            'PanTool',
            'SelectionTool',
            'SearchOption',
            'PrintOption',
            // 'DownloadOption',
            'UndoRedoTool',
            'AnnotationEditTool',
            'CommentTool',
            // 'SubmitForm'
        ],
        annotationToolbarItems: [
            'HighlightTool',
            'UnderlineTool',
            'StrikethroughTool',
            // 'ShapeTool',
            'CalibrateTool',
            'ColorEditTool',
            'StrokeColorEditTool',
            'ThicknessEditTool',
            'OpacityEditTool',
            'AnnotationDeleteTool',
            'StampAnnotationTool',
            // 'HandWrittenSignatureTool', //  does not work in BE
            'InkAnnotationTool', // does not work in BE
            'FreeTextAnnotationTool',
            'FontFamilyAnnotationTool',
            'FontSizeAnnotationTool',
            'FontStylesAnnotationTool',
            'FontAlignAnnotationTool',
            'FontColorAnnotationTool',
            'CommentPanelTool',
        ],
    };
    constructor(
        private store: Store<State>,
        private api: HttpService,
        private fs: FileDataService,
        public LS: LoadingService,
        private elementRef: ElementRef,
        public BS: BreakpointObserverService,
        private actions$: Actions,
        private pts: PdfToolsService,
        private fds: FileDataService,
        private dialog: MatLegacyDialog,
        private matDialog: MatDialog,
        private toastrService: ToastrService,
    ) {

    }
    ngAfterViewInit(): void {
        firstValueFrom(this.store.select(getToken).pipe(filter(isNotNullOrUndefined))).then((token) => {
            this.PdfViewer.ajaxRequestSettings.ajaxHeaders = [
                {
                    headerName: 'Authorization',
                    headerValue: 'Bearer ' + token,
                },
            ];
            const body = { versionId: this.Version.Id };
            this.LS.startLoading('getPDFElements');
            fetch(this.ServiceGetElements, {
                method: 'Post',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json();
                })
                .then(async data => {
                    const isEmpty =
                        data === null ||
                        data === undefined ||
                        (typeof data === 'string' && data.trim() === '') ||
                        (Array.isArray(data) && data.length === 0) ||
                        (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0);
                    this.LS.endLoading('getPDFElements');
                    if (isEmpty) {
                        this.loadedVersion = this.Version;
                        // this.PdfViewer.load(this.loadedVersion.Id + '', null);
                        this.loadPdfFromFileService(this.loadedVersion);

                    } else {
                        this.dialog
                            .open<PdfEditableDialogComponent, PDFEditableDialogData, PDFEditableDialogReturnData>(PdfEditableDialogComponent, {})
                            .afterClosed()
                            .subscribe(async (selectedOption) => {
                                this.LS.startLoading('upload-optimised-pdf-version');
                                if(selectedOption) {
                                    const res = await this.pts.convertPDFToImage({
                                        VersionId: this.Version.Id.toString(),
                                        OnlyOnePage: false,
                                        MaxDimension: "5000"
                                    });
                                    const documentIds: number[] = res.DocumentIds.map((i) => Number(i));

                                    const files = await firstValueFrom(this.fds.GetFilesById(documentIds));

                                    let imgVersionIds: string[] = [];

                                    files.forEach((file) => {
                                        imgVersionIds.push(file.Versions[0].Id.toString());
                                    });

                                    const bodyUploadNewVersionFromImages = {
                                        documentId: this.Version.DocumentId,
                                        imgIds: imgVersionIds.join(',')
                                    };
                                    fetch(this.ServiceUploadNewVersionFromImages, {
                                        method: 'Post',
                                        headers: {
                                            'Authorization': 'Bearer ' + token,
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify(bodyUploadNewVersionFromImages)
                                    })
                                        .then(response => {
                                            return response.json();
                                        })
                                        .then(async data => {
                                            if (data) {
                                                this.loadedVersion = data.version.id;
                                                // this.PdfViewer.load(this.loadedVersion + '', null);
                                                this.loadPdfFromFileService(this.loadedVersion);
                                            }
                                            this.LS.endLoading('upload-optimised-pdf-version');
                                        }).catch(err => {
                                        this.toastrService.error('Fehler beim umwandeln der PDF.', 'Fehler');
                                        this.LS.endLoading('upload-optimised-pdf-version');
                                    });
                                }//selectedOption
                                else{
                                    this.LS.endLoading('upload-optimised-pdf-version');
                                }
                            });
                    } //else
                })

            /* enableTextSelection = false, ermöglicht Scrollen am Tablet, aber dafür kann man nicht mehr Texte auswählen & kopieren */
            // this.PdfViewer.enableTextSelection = false
            // this.FileLoaded.emit();
            if (this.SigningMode) {
                firstValueFrom(this.PdfViewer.documentLoad).then(() => {
                    if (!this.Editing) {
                        this.Edit();
                    }
                    this.OpenSignaturePopup();
                    const scroller = this.elementRef.nativeElement.querySelector('.e-pv-viewer-container');
                    scroller.scrollTop = scroller.childNodes[0].offsetHeight;
                });
            }
            if (this.SetMapMarkerMode) {
                setTimeout(() => {
                    this.startSetMarkerMode();
                }, 1000);
            }

            firstValueFrom(this.PdfViewer.documentLoad).then(() => {
                this.viewerContainer = this.elementRef.nativeElement.querySelector('.e-pv-page-container');
                this.setupEditListener();
                this.setEventListener();
            });

            this.CheckedFile$.pipe(takeUntil(this.destroy$), distinctUntilChanged((a,b)=> a?.Id === b?.Id)).subscribe((f) => {
                if(isNotNullOrUndefined(f.Remark) && f.Remark != "") {
                    const openedToasts = this.toastrService.toasts;
                    for (const toast of openedToasts) {
                      if (toast.toastRef.componentInstance.toastPackage.toastType === 'toast-warning') {
                        this.toastrService.clear(toast.toastId);
                      }
                    }
                    this.toastrService.warning(f.Remark, 'Bemerkung:', {messageClass: 'font-bold'});
                }
            })
        });
    }

    public ajaxRequestInitiate(args: any) {
        if (args?.JsonData && (args.JsonData.action === 'Download' || args.JsonData.action === 'RenderPdfPages')) {
            args.JsonData.documentId = this.loadedVersion.Id;
        }
    }

    async loadPdfFromFileService(version: VersionEntity) {
        const pdf = await firstValueFrom(this.api.download(version));

        if (pdf) {
            const base64 = await blobToBase64(pdf);
            console.log('Document data as Base64:', base64);
            this.PdfViewer.load(base64 as string, null);
        }
    }
    ngOnDestroy() {
        this.destroy$.next()
        this.unsubscribeTimerSubs();
        this.editSubject.complete();
        this.destroy$.complete()
        this.Close();
    }

    /**
     * Beendet alle laufenden Timer-Subscriptions und Debounce-Subscriptions für den Autosave-Timer.
     */
    private unsubscribeTimerSubs() {
        // Timer Subscription beenden, falls diese läuft
        this.stopAutosaveTimer();
        // Debounce Subscription beenden, falls diese läuft
        if (this.debounceSub) {
            this.debounceSub.unsubscribe();
            this.debounceSub = undefined;
        }
    }

    canDeactivate(): Observable<boolean> | boolean {
        const edited = this.PdfViewer?.isDocumentEdited;
        if (edited != null) {
            return !edited;
        }
        // Fallback, falls Viewer noch nicht existiert
        return !this.SaveButton;
    }
    Close() {
        this.fs.GetFileById$(this.Version.DocumentId, true).pipe(take(1)).subscribe();
        try {
            this.PdfViewer.unload();
        } catch (e) {
            console.error('PdfViewer.unload failed', e);
        }
        try {
            this.PdfViewer.destroy();
        } catch (e) {
            console.error('PdfViewer.destroy failed', e);
        }
    }
    Edit() {
        this.SaveButton = true;
        this.Editing = !this.Editing;

        if (!this.autosaveTimerRunning && this.Editing) {
            this.editSubject.next();
            this.startAutosaveTimer();
        }

        this.PdfViewer.toolbar.showAnnotationToolbar(this.Editing);
        if (this.Editing == false) {
            this.stopAddCheckAnnotations();
        }
        this.PdfViewer.contextMenuSettings = {
            contextMenuAction: 'RightClick',
            contextMenuItems: [ContextMenuItem.Copy, ContextMenuItem.Cut, ContextMenuItem.Paste, ContextMenuItem.Delete, ContextMenuItem.Comment],
        };
        // console.log(this.PdfViewer.toolbar)
        // console.log(this.PdfViewer.toolbar.annotationToolbarModule)
        // console.log(this.PdfViewer.toolbar.annotationItem)
        // this.PdfViewer.toolbar.annotationItem.click()
    }

    /**
     * Startet den Autosave-Timer, der in einem festgelegten Intervall die automatische Speicherung auslöst.
     */
    private startAutosaveTimer() {
        this.autosaveTimerRunning = true;
        const firstTickTime = !this.PdfViewer.isDocumentEdited ? this.AUTOSAVE_INTERVAL : 1_000;

        this.autosaveTimerSub = timer(firstTickTime, this.AUTOSAVE_INTERVAL)
            .subscribe(() => {
                this.autosave()
            });
    }

    /**
     * Stoppt den Autosave-Timer, falls er läuft.
     */
    private stopAutosaveTimer() {
        if (this.autosaveTimerSub) {
            this.autosaveTimerSub.unsubscribe();
            this.autosaveTimerSub = null;
            this.autosaveTimerRunning = false;
        }
    }

    /**
     * Diese Methode wird aufgerufen, um das PDF-Dokument automatisch zu speichern.
     */
    autosave() {
        this.PdfViewer.serviceUrl = this.autosaveServiceUrl;
        this.PdfViewer.download();
        this.PdfViewer.serviceUrl = this.ServiceUrl;
    }

    /**
     * Diese Methode wird aufgerufen, wenn eine Änderung im PDF-Viewer erfolgt.
     * Sie löst das editSubject aus und startet den Autosave-Timer, falls er nicht bereits läuft.
     */
    private onEdit() {
        this.editSubject.next();
        if (!this.autosaveTimerRunning && this.SaveButton) {
            this.startAutosaveTimer();
        }
    }

    /**
     * Richtet die Debounce-Funktion für den editSubject ein.
     * Falls innerhalb der angegebenen Zeit keine Änderungen mehr erfolgen, wird der Autosave-Timer gestoppt.
     */
    private setupEditListener() {
        this.debounceSub = this.editSubject
            .pipe(debounceTime(this.STOP_AUTOSAVE_TIME))
            .subscribe(() => {
                // Keine Änderungen mehr seit x Sekunden: Timer stoppen
                this.stopAutosaveTimer();
            });
    }

    async Save() {

        // Edit-Bar soll nach dem Speichern nicht mehr angezeigt werden
        this.PdfViewer.toolbar.showAnnotationToolbar(false);

        // Wenn der Autosave-Timer läuft, wird er gestoppt
        this.stopAutosaveTimer();

        const customDownloadHeaderName = 'Download-Type';
        // @ts-ignore
        // const hashId = this.PdfViewer.navigationModule.pdfViewerBase.hashId;
        // console.log('save \nversionId: ' + this.loadedVersion.Id, '\nhashId: ' + hashId);
        this.stopAddCheckAnnotations();
        this.LS.startLoading('save-pdf-on-server-side');
        this.PdfViewer.annotation.setAnnotationMode('None');
        this.PdfViewer.ajaxRequestSettings.ajaxHeaders.push({
            headerName: customDownloadHeaderName,
            headerValue: 'without-response-file',
        });
        this.PdfViewer.download();
        this.PdfViewer.ajaxRequestSettings.ajaxHeaders = this.PdfViewer.ajaxRequestSettings.ajaxHeaders.filter((h) => h.headerName !== customDownloadHeaderName);
        const event = await firstValueFrom(
            merge(
                this.PdfViewer.downloadEnd as EventEmitter<{ fileName: string; downloadDocument: string; name: 'downloadEnd' }>,
                (this.PdfViewer.ajaxRequestFailed as EventEmitter<{ name: 'ajaxRequestFailed'; documentName: string; errorStatusCode: number; errorMessage: string; action: string }>).pipe(filter((event) => event.action === 'Download')),
            ),
        );
        this.LS.endLoading('save-pdf-on-server-side');
        if (event?.name === 'downloadEnd') {
            this.toastrService.success('PDF erfolgreich gespeichert');
            this.SaveButton = false;
            this.Editing = false;
            this.PdfViewer.isDocumentEdited = false;
            this.fs.pollFilesAndLinksByVersionId(this.Version.Id);
        } else {
            this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'PDF speichern fehlgeschlagen', Err: event.errorMessage } }));
        }
        setTimeout(() => this.fs.pollFilesAndLinksByVersionId(this.Version.Id), 3500);
        setTimeout(() => this.fs.pollFilesAndLinksByVersionId(this.Version.Id), 10000);
    }
    changeChecked() {
        this.CheckedFile$.pipe(
            take(1)
        ).subscribe((file) => {
            this.store.dispatch(
                FilesActionTypes.ModifyFileRequest({
                    Payload: {
                        DocumentId: this.SetCheckedButtonDocumentId.toString(),
                        Checked: !file.Checked,
                    },
                })
            )
        });

        this.LS.startLoading('save-pdf-on-server-side_changeChecked');

        firstValueFrom(merge(
            this.actions$.pipe(ofType(FilesActionTypes.ModifyFileSuccess)),
            this.actions$.pipe(ofType(FilesActionTypes.ModifyFileFailure))
        )).then((action) => {
            this.LS.endLoading('save-pdf-on-server-side_changeChecked');
            if (action.type === FilesActionTypes.ModifyFileSuccess.type) {
                this.toastrService.success('Dokumentstatus erfolgreich gespeichert');
            } else if (action.type === FilesActionTypes.ModifyFileFailure.type) {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Dokumentstatus speichern fehlgeschlagen',
                            Err: action.Payload.Errors,
                        },
                    }),
                );
            }
        });
    }
    OpenSignaturePopup() {
        // let addSignatureButton = document.querySelector('#pdfViewer_annotation_signature-popup [aria-label="ADD SIGNATURE"] button');
        // if (!addSignatureButton) {
        //     if (!this.PdfViewer.toolbarModule.annotationToolbarModule.toolbarCreated) {
        //         this.PdfViewer.toolbarModule.annotationItem.click();
        //     }
        //     this.PdfViewer.toolbarModule.annotationToolbarModule.handWrittenSignatureItem.click();
        //     addSignatureButton = document.querySelector('#pdfViewer_annotation_signature-popup [aria-label="ADD SIGNATURE"] button');
        // }
        // (addSignatureButton as HTMLElement).click();
        this.stopAddCheckAnnotations();
        this.PdfViewer.handWrittenSignatureSettings = { strokeColor: '#00796b' };
        this.PdfViewer.annotationModule.setAnnotationMode('HandWrittenSignature');
    }

    OpenRemark() {
        window.addEventListener('keydown', this.pauseViewer, true);

        this.CheckedFile$.pipe(
            take(1)
        ).subscribe((file) => {
            this.matDialog.open<RemarkPopupComponent, RemarkPopupComponentDialogData>(RemarkPopupComponent, {
                ...RemarkPopupComponent.DefaultConfig,
                data: {
                    FileId: file.Id,
                },
            }).afterClosed().pipe(
                take(1),
            ).subscribe((res) => {
                window.removeEventListener('keydown', this.pauseViewer, true);
            })
        })
    }

    // Ignoriert Tasteneingaben für Events, sonst führt zu Perfomance Problemen bei Tastatur Eingaben im Dialog
    public pauseViewer = (event: KeyboardEvent) => {
        event.stopPropagation();
    };

    public setEventListener() {
        // annotationAdd
        // annotationDoubleClick
        // annotationMouseLeave
        // annotationMouseover
        // annotationMove
        // annotationMoving
        // annotationPropertiesChange
        // annotationRemove
        // annotationResize
        // annotationSelect
        // annotationUnSelect

        // MouseUp Event für das Beenden des Zeichnens von Ink-Annotationen
        this.viewerContainer.addEventListener('mouseup', () => {
            if (this.PdfViewer.tool === 'Ink'){
                setTimeout(() => {
                    this.PdfViewer.annotationModule.setAnnotationMode('None');
                    this.PdfViewer.toolbar.annotationToolbarModule.inkAnnotationItem.click()
                }, 200);
            }
        });

        // Fügt die Edit-Events hinzu, um auf Änderungen im PDF-Viewer zu reagieren
        this.editEvents.forEach(editEventName => {
            this.PdfViewer.addEventListener(editEventName, () => {
                this.onEdit();
            });
        });

        this.PdfViewer.addEventListener('annotationSelect', (event) => {
            const anotation = this.PdfViewer.annotationCollection.find((a) => a.annotationId === event.annotationId);
            if (((anotation?.customStampName as string) || '').startsWith(PROGRAMMATICALLY_ANNOTATION_PREFIX)) {
                const regex = /eventId:([1-9]*);/g;
                const match = regex.exec(anotation.customStampName);
                const eventId = +match[1];
            }
        });
    }
    public checkModeActive = false;
    public toggleAddCheckAnnotations() {
        if (this.checkModeActive) {
            this.stopAddCheckAnnotations();
        } else {
            this.startAddCheckAnnotations();
        }
    }

    public onAnnotationAdd(event) {
        // console.log(this.checkModeActive)
        if (this.checkModeActive && event.name === 'annotationAdd' && event.annotationType === 'Stamp') {
            setTimeout(() => this.startAddCheckAnnotations(), 10);
        }
        // else if (!this.checkModeActive) {
        //     this.PdfViewer.annotationModule.deleteAnnotationById(event.annotationId);
        // }
    }
    public stopAddCheckAnnotations() {
        this.checkModeActive = false;

        // this.PdfViewer.annotationModule.clearSelection();
        // this.PdfViewer.annotationModule.deleteAnnotationById(this.PdfViewer.annotations[length -1].properties.id)
        // console.log(this.PdfViewer.annotations);
        // console.log(this.PdfViewer.annotations[this.PdfViewer.annotations.length -1]);
        // const id = this.PdfViewer.annotations[this.PdfViewer.annotations.length -1]['properties']['id'];
        // this.PdfViewer.annotationModule.deleteAnnotation()
        // console.log(this.PdfViewer.annotationAdd) <-- works on desktop
        // console.log(this.PdfViewer.annotationModule.stampAnnotationModule.currentStampAnnotation)
        // this.PdfViewer.annotationModule.deleteAnnotationById(id)
        this.PdfViewer.annotationModule.setAnnotationMode('None', null, null, null);
    }
    public startAddCheckAnnotations() {
        this.checkModeActive = true;
        this.PdfViewer.annotationModule.setAnnotationMode('Stamp', null, SignStampItem.Accepted, null);
        this.PdfViewer.annotationModule.stampAnnotationModule.currentStampAnnotation.width = this.PdfViewer.annotationModule.stampAnnotationModule.currentStampAnnotation.width * 0.1;
        this.PdfViewer.annotationModule.stampAnnotationModule.currentStampAnnotation.height = this.PdfViewer.annotationModule.stampAnnotationModule.currentStampAnnotation.height * 0.1;
    }
    public startSetMarkerMode() {
        // this.PdfViewer.annotationModule.setAnnotationMode('Image');
        this.PdfViewer.toolbarModule.annotationToolbarModule.createCustomStampElement();
        urltoFile(MAP_MARKER_BASE64, 'test.svg', 'image/svg+xml').then((file) => {
            this.PdfViewer.toolbarModule.annotationToolbarModule.addStampImage({ target: { files: [file] }, currentTarget: {} });
        });
        // this.PdfViewer.toolbarModule.annotationToolbarModule.

        // this.PdfViewer.annotationModule.triggerAnnotationAdd({
        //     data:
        //     MAP_MARKER_BASE64        })
    }
    getAnnotation() {
        return this.PdfViewer.annotationCollection;
    }

    addEventAnnotation(event: EventEntity, canMove = false) {
        const marker = event.AdditionalData?.mapMarker ? event.AdditionalData.mapMarker[this.Version.DocumentId] : undefined;
        if (marker) {
            marker.forEach((m) => this.addAnnotation(m.left, m.top, /*marker.page,*/ 'eventId:' + event.Id + ';', canMove));
        }
    }

    public addAnnotation(/*x : number, y : number, page: number,*/ left: number, top: number, uniqId: string, canMove = false) {
        const allowedInteractions = [AllowedInteraction.Delete];
        if (canMove) {
            allowedInteractions.push(AllowedInteraction.Move);
        }
        const options: Partial<CustomStampSettings> = {
            offset: { x: left, y: top },
            // left,
            // top,
            width: 16,
            author: ProductName,
            height: 32,
            isLock: true,
            allowedInteractions,
            // pageNumber: page,
            customStamps: [
                {
                    customStampName: PROGRAMMATICALLY_ANNOTATION_PREFIX + uniqId,
                    customStampImageSource: MAP_MARKER_BASE64,
                },
            ],
        };
        this.PdfViewer.annotation.addAnnotation('Stamp', options as CustomStampSettings);
    }
    public removeAnnotation() {
        this.PdfViewer.annotationCollection
            .filter((annotation) => (annotation.customStampName as string).startsWith(PROGRAMMATICALLY_ANNOTATION_PREFIX))
            .forEach((annotation) => {
                this.PdfViewer.annotationModule.deleteAnnotationById(annotation.annotationId);
            });
    }
    public resize() {
        this.PdfViewer.updateViewerContainer();
    }

    documentLoad() {
        this.FileLoaded.emit();
        // prevent chrome autoscroll on start drawing
        const wrapper: HTMLDivElement = document.querySelector('.e-pv-viewer-container');
        const pages = document.querySelectorAll<HTMLDivElement>('.e-pv-text-layer');
        if (wrapper && pages?.length) {
            pages.forEach((page) => {
                page.addEventListener('mousedown', (event) => {
                    if (document.activeElement !== wrapper) {
                        wrapper.focus({ preventScroll: true });
                    }
                });
            });
        }
    }

    protected readonly DocumentState = DocumentState;
}
const PROGRAMMATICALLY_ANNOTATION_PREFIX = '#_programmatically_added_annotation_#';
const MAP_MARKER_BASE64 =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzODQgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuNC4yIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIzIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNMjE1LjcgNDk5LjJDMjY3IDQzNSAzODQgMjc5LjQgMzg0IDE5MkMzODQgODYgMjk4IDAgMTkyIDBTMCA4NiAwIDE5MmMwIDg3LjQgMTE3IDI0MyAxNjguMyAzMDcuMmMxMi4zIDE1LjMgMzUuMSAxNS4zIDQ3LjQgMHpNMTkyIDEyOGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDEgMSAwLTEyOHoiLz48L3N2Zz4=';
// return a promise that resolves with a File instance
async function urltoFile(url: string, filename: string, mimeType?: string) {
    if (url.startsWith('data:')) {
        var arr = url.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], filename, { type: mime || mimeType });
        return Promise.resolve(file);
    }
    let res = await fetch(url);
    let buf: ArrayBuffer = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
}
